<template>
    <div>
        <Modal v-model="show">
            <EmployeeLeaveChart ref="EmployeeChart" :chart-data="leaves" />
            <Table :columns="columns" :data="employeeLeaves"></Table>
        </Modal>
    </div>
</template>

<style scoped lang="scss"></style>

<script setup>
import { getEmployeeLeaves } from '@/components/Admin/LeaveSummary/services/leave-summary.service.ts';
import EmployeeLeaveChart from '@/components/Admin/LeaveSummary/EmployeeLeaveChart.vue';
import { getReformattedLeaves } from '@/components/Admin/LeaveSummary/utils/leaveSummaryFormatter.ts';

export default {
    components: { EmployeeLeaveChart },
    data() {
        return {
            leaves: {},
            columns: [
                { title: 'Leave Type', key: 'status' },
                { title: 'Date', key: 'clockInTime' },
            ],
            employeeLeaves: [],
            show: false,
        };
    },
    async mounted() {},
    methods: {
        async showModal(employeeId) {
            try {
                const { data } = await getEmployeeLeaves(employeeId);
                this.employeeLeaves = data[0].main[0].leaves;
                const { chartData } = await getReformattedLeaves(data[0].stats);
                this.leaves = chartData;
            } catch (err) {
                console.log('err: ', err);
            } finally {
                this.show = true;
            }
        },
    },
};
</script>
